import { create } from "zustand";

type ModalState = {
  isModalOpen: boolean;
  openModal: () => void;
  closeModal: () => void;
  toggleModal: () => void;
};

export const useModalState = create<ModalState>(set => ({
  isModalOpen: false,

  openModal: () =>
    set(() => ({ isModalOpen: true })),

  closeModal: () =>
    set(() => ({ isModalOpen: false })),

  toggleModal: () =>
    set(state => ({ isModalOpen: !state.isModalOpen })),
}));
